import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const ChecklistsPage = lazy(() => import('../pages/ChecklistsPage'));
const ChecklistPageReceived = lazy(() => import('../pages/ChecklistPageReceived'));
const ChecklistPageCreated = lazy(() => import('../pages/ChecklistPageCreated'));

export interface IRoute {
  path: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.CHECKLIST,
    component: ChecklistsPage,
    accessDeniedDescription: 'ver checklists',
    routes: [
      {
        path: Location.CHECKLIST_RECEIVED,
        component: ChecklistPageReceived,
        accessDeniedDescription: 'ver checklists recebidas',
        exact: true,
      },
      {
        path: Location.CHECKLIST_CREATED,
        component: ChecklistPageCreated,
        accessDeniedDescription: 'ver checklists criadas',
        exact: true,
      },
    ],
  },
];

export default routes;
